<input type="text" #searchInput placeholder="Enter in your address here" class="form-control" />
